//список артикулов данных, которые используются в формах, но только на фронте
export const frontOnlyArticles = ['fieldsVisibility', 'fieldsDescriptions', 'fieldsDisabled', 'modal_info']
const articles = frontOnlyArticles

const valuesCleaner = (values: { [key: string]: any }) => {
    const valuesClone = { ...values }
    articles.forEach((article) => delete valuesClone[article])

    // Удаляем пустые значения из запроса
    Object.keys(valuesClone).forEach((key) => {
        const value = valuesClone[key]
        // Удаляем null, undefined, пустые строки, пустые массивы
        if (
            value === null ||
            value === undefined ||
            value === '' ||
            (Array.isArray(value) && value.length === 0) ||
            (typeof value === 'object' && value !== null && !Array.isArray(value) &&
                (Object.keys(value).length === 0 || Object.values(value).every(v => v === null || v === undefined || v === '')))
        ) {
            delete valuesClone[key]
        }
    })

    return valuesClone
}

export default valuesCleaner
